import ajax from '@/helpers/ajax'

export default {
  linkCampaignWithUnconfirmedUser({ state }, userToken) {
    ajax.put({
      url: state.linkUserUrl,
      data: {
        user_token: userToken
      },
      errorHandler: (response) => {
        window.errorLogger.error(`Error linking campaign with user: ${response}`)
      }
    })
  },

  moderateWithOneClickAndRedirect({ state, commit, dispatch }) {
    ajax.patch({
      url: state.oneClickModerationUrl,
      data: {
        [state.entityType]: { admin_status: 'good' }
      },
      successHandler: (response) => {
        if (response.redirectUrl) {
          commit('setRedirectUrl', response.redirectUrl)
        }
        dispatch('redirect')
      }
    })
  },

  redirect({ state }) {
    if (state.redirectUrl) {
      window.location = state.redirectUrl
    }
  }
}
